import { sys } from "@/Core/utils/system";
import { fetcher, useAPI, useAPIMutation } from "@/api/api";
import {
  IFActivityEntry,
  IFBanner,
  IFBigWins,
  IFHomeRsp,
  IFMarquee,
} from "@/api/apiRsp/IFHomeRsp";
import { IFGameTypeRsp } from "@/api/apiRsp/IFGameTypeRsp";

import useSWR from "swr";
import { useGlobalState } from "./commonStore";
import {
  CasinoHomeData,
  fetchCasinoHomeData,
  getCasinoSWRKey,
} from "./homeCasino";

export class HomeSWRWalletKey {
  //切换法币充值
  public static get getRedrainConfig() {
    return `getActivityEntry?${sys.token}`;
  }
}

export function useCasino() {
  const { isLogin, token } = useGlobalState();
  const swrKey = getCasinoSWRKey(token, isLogin);
  const { data, mutate, isLoading, error, isValidating } =
    useSWR<CasinoHomeData>(
      swrKey,
      () => fetchCasinoHomeData(token, isLogin, fetcher),
      {
        dedupingInterval: 60 * 1000,
      }
    );

  return {
    isLoading,
    error,
    homeData: data?.lobbyData as IFHomeRsp | undefined,
    bigWinsData: data?.bigWinsData as IFBigWins[] | undefined,
    playedPreviewData: data?.playedPreviewData as IFGameTypeRsp | undefined,
    mutate,
    isValidating,
  };
}

// 新增：单独获取大赢家数据的 hook
export function useBigWins() {
  const { data, mutate, isLoading, error, isValidating } = useSWR<any>(
    "getBigWins",
    () => {
      return fetcher({ path: "/api/game/bigwinnings", type: "get" }, {}).then(
        (res) => {
          return res;
        }
      );
    },
    {
      dedupingInterval: 60 * 1000,
    }
  );



  return {
    bigWinsData: data,
    isLoading,
    error,
    mutate,
    isValidating,
  };
}

//首页banner
export function useBanner() {
  const fetch = () => {
    return fetcher(
      {
        path: "/api/index/banner",
        type: "post",
      },
      {}
    ).then((res: IFBanner[]) => {
      return res || [];
    });
  };
  return useSWR(sys.token + "useBanner", fetch, {
    dedupingInterval: 5 * 60 * 1000,
  });
}

//首页活动
export function useActivityEntryPlus(revalidateOnMount = true) {
  const fetch = () => {
    return fetcher<IFActivityEntry>(
      {
        path: "/api/index/activity/entry",
        type: "get",
      },
      {}
    );
  };

  return useSWR<IFActivityEntry>(HomeSWRWalletKey.getRedrainConfig, fetch, {
    dedupingInterval: 60 * 1000,
    revalidateOnMount,
  });
}

//首页滚动通知
export function useMarqueeList() {
  const { data, error, isLoading, isValidating, revalidate } = useAPI<
    Array<IFMarquee>,
    any
  >({ path: "/api/index/marquee", type: "get" });

  if (data && data.length) {
    for (let i = 0; i < data.length; i++) {
      data[i].content = decodeURIComponent(data[i].content);
    }
  }

  return {
    MarqueeData: data,
    MarqueeIsLoading: isLoading,
    MarqueeIsValidating: isValidating,
    MarqueeError: error,
    MarqueeRevalidate: revalidate,
  };
}
